import React from 'react';

export const WhyWeSpecialize: React.FC = () => {
  const reasons = [
    {
      title: 'Deep Market Knowledge',
      description: 'Our team has extensive experience evaluating and purchasing garden apartment properties across diverse markets. We understand the unique characteristics, operating expenses, and value drivers specific to garden-style communities.',
      points: [
        'Comprehensive understanding of suburban rental markets',
        'Experience with properties ranging from 20 to 500+ units',
        'Knowledge of regional construction styles and building systems',
        'Familiarity with local zoning and land use regulations'
      ]
    },
    {
      title: 'Fair Valuation Approach',
      description: 'We recognize that garden apartments have distinct valuation considerations compared to other multifamily property types. Our offers reflect realistic assessments of property condition, market position, and income potential.',
      points: [
        'Consideration of land value and development potential',
        'Analysis of deferred maintenance and capital needs',
        'Evaluation of tenant mix and lease structures',
        'Assessment of competitive positioning in local markets'
      ]
    },
    {
      title: 'Flexible Transaction Structures',
      description: 'Garden apartment owners often have unique circumstances and goals. We offer multiple purchase options to accommodate different seller needs and timelines.',
      points: [
        'All-cash purchases for quick closings',
        'Seller financing options for tax advantages',
        'Leaseback arrangements if needed',
        'Flexible closing dates to match your schedule'
      ]
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-orange-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Why We Specialize in Garden Apartments
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
            Garden apartments require specialized knowledge and experience. We've built our business around understanding these unique properties.
          </p>
        </div>

        <div className="mb-16">
          <div className="relative overflow-hidden rounded-2xl shadow-2xl">
            <img
              src="https://public.readdy.ai/ai/img_res/41ed5f13bdf0a672beff0177feced751.jpg"
              alt="Professional Real Estate Team"
              className="w-full h-[450px] object-cover object-top"
            />
          </div>
        </div>

        <div className="space-y-12">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg p-8 md:p-10 hover:shadow-xl transition-shadow duration-300"
            >
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                {reason.title}
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed mb-8">
                {reason.description}
              </p>
              <div className="grid md:grid-cols-2 gap-4">
                {reason.points.map((point, idx) => (
                  <div key={idx} className="flex items-start">
                    <div className="flex-shrink-0 w-6 h-6 bg-orange-500 rounded-full flex items-center justify-center mt-1 mr-3">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <p className="text-gray-700 leading-relaxed">{point}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};